<template>
  <div class="page_ blue_">
    <div class="steps">
      <span class="left">{{ $t("claimDetails[0]") || "事后" }}</span>
      <span class="no"
        >{{ $t("claimDetails[1]") || "报案编号："
        }}{{ claimsItem.cliamsId }}</span
      >
      <span>
        <img class="cicle" src="../assets/medilinkPC/cicle.png" alt="" />
        <span>{{ claimsItem.claimsDesc }}</span>
      </span>
      <div class="change_account">
        <!-- <span @click="changeAccount">{{$t('claimDetails[2]')||'变更账户'}}</span> -->
        <!-- <span @click="goDetail">{{$t('alertPrompt[6]')||'查看详情'}}</span> -->
      </div>
    </div>
    <div class="step_3">
      <p style="padding: 0 59px 0 30px;">
        {{ $t("claim[60]") || "为了顺利通过审核，请提供以下材料" }}
      </p>
      <a-row
        style="margin-top: 20px;padding: 0 59px 0 30px; display:flex;flex-wrap:wrap;"
      >
        <a-col
          :span="7"
          v-for="(item, index) in fileList"
          :key="index"
          :offset="index % 3 == 0 ? '0' : '1'"
          style="margin-bottom:30px;"
        >
          <a-row type="flex">
            <a-col style="max-width:74%;display:flex;align-items:center;">
              <img
                class="cicle"
                src="../assets/medilinkPC/cicle.png"
                alt=""
                v-if="
                  claimsItem.claimsType != '1' &&
                    claimsItem.claimsType != '2' &&
                    item.isFill == '1'
                "
              />
              <span
                class="tit tit1"
                :title="$i18n.locale == 'zh-cn' ? item.cName : item.eName"
                >{{ $i18n.locale == "zh-cn" ? item.cName : item.eName }}</span
              ></a-col
            >
            <!-- <a-col v-if="item.type == 'CA'"><a href="">{{$t('InsuranceInfo[30]')||'表单下载'}}</a></a-col> -->
            <a-col
              ><a href="javascript:;" class="hover_bold" @click="exam(index)">{{
                $t("claim[52]") || "示例"
              }}</a></a-col
            >
          </a-row>
          <a-row>
            <a-col :span="8" class="addlist">
              <div
                class="list-item"
                v-for="(item2, index2) in uploadFileList"
                :key="index2"
              >
                <div v-if="item2.imageType == item.type">
                  <span>{{ item2.imageName }}</span>
                  <span class="remove" @click="removeFile(index2)">x</span>
                </div>
              </div>
            </a-col>
          </a-row>
          <a-row class="mt_">
            <a class="hover_bold"
              ><input
                @change="uploadPhoto($event, item.type)"
                type="file"
                class="kyc-passin "
                style="opacity: 0;width:100px"
              />{{ $t("claim[53]") || "上传文件" }}</a
            >
          </a-row>
        </a-col>
      </a-row>
    </div>
    <div class="bottom_">
      <span class="remark_">{{ $t("claim[39]") || "备注" }}</span>
      <a-textarea
        style="margin-top: 17px;"
        :rows="4"
        v-model="value"
        :placeholder="
          $t('alertPrompt[7]') || '请输入您对理赔的其他要求（200字以内）'
        "
      />
    </div>
    <a-row type="flex" justify="end" style="margin-top: 20px;">
      <a-button type="primary" style="margin-right: 20px;" @click="submit">{{
        $t("claim[49]") || "确认提交"
      }}</a-button>
      <a-button @click="back">{{ $t("claimDetails[4]") || "返回" }}</a-button>
    </a-row>
    <a-modal v-model="imgVisible" :footer="null">
      <p v-if="showImgList.length == 0">暂无示例图片</p>
      <img
        :src="item.templateUrl"
        alt=""
        style="width: 100%"
        v-for="(item, index) in showImgList"
        v-else
      />
    </a-modal>
    <div class="fixbg1" v-if="isLoading">
      <a-spin />
    </div>
  </div>
</template>

<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.page_ {
  // background-color: #fff;
  width: 100%;
  height: 100%;
  // padding: 17px 27px 0 27px;
  border-radius: 10px;
  color: #394155;
  padding-bottom: 20px;
  .steps {
    position: relative;
    background-color: #fff;
    height: 55px;
    line-height: 55px;
    width: 100%;
    font-size: 16px;
    // color: #cccccc;
    border-bottom: 1px #f3f3f3 solid;

    .left {
      margin-left: 29px;
      // display: inline-block;
      font-size: 10px;
      border: 1px #2c5acc solid;
      margin-right: 20px;
      text-align: center;
      color: #2c5acc;
      border-radius: 3px;
      padding: 1px 5px;
    }
    .cicle {
      width: 10px;
      height: 10px;
      margin-bottom: 5px;
      margin-left: 130px;
    }
    .no {
      font-size: 16px;
      font-weight: 500;
    }
    .change_account {
      color: #2c5acc;
      position: absolute;
      top: 12px;
      right: 30px;
      display: flex;
      span {
        height: 30px;
        line-height: 30px;
        display: inline-block;
        padding: 0 15px;
        margin-left: 10px;
        cursor: pointer;
        &:hover {
          font-weight: bold;
        }
      }
    }
    .cancel_apply {
      color: #2c5acc;
      position: absolute;
      top: 0;
      right: 30px;
    }
    .step_item {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      img {
        width: 17px;
        height: 17px;
      }
      .arrow_ {
        position: absolute;
        right: 0;
        font-size: 20px;
        color: #cccccc;
      }
      .arrow_blue {
        color: #2c5acc;
      }
    }
    .blue {
      border-bottom: 3px #2c5acc solid;
      color: #2c5acc;
    }
    .arrow_blue {
      color: #2c5acc;
    }
  }
  .step_1 {
    background-color: #fff;
    padding-top: 167px;
    padding-left: 336px;
    line-height: 24px;
    .attention_ {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 14px;
    }
    .next_ {
      margin-top: 38px;
    }
  }
  .step_2 {
    // background-color: #fff;
    // height: 144px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    .top_ {
      padding-top: 38px;
      background-color: #fff;
      height: 144px;
      margin-bottom: 20px;
    }
    .card_ {
      width: 100%;
      height: 560px;
      border-radius: 10px;
      background-color: #fff;
      padding: 27px 29px 0 29px;
      .account_ {
        margin-top: 16px;
        margin-bottom: 17px;
        position: relative;
        padding-left: 16px;
        // &::before {
        //   position: absolute;
        //   content: '';
        //   display: block;
        //   width: 7px;
        //   height: 7px;
        //   border-radius: 50%;
        //   background-color: #2C5ACC;
        // }
        // .text_ {
        .arrow_ {
          &::after {
            content: "";
            display: block;
            height: 0;
            width: 0;
            position: absolute;
            top: 7px;
            left: 0;
            border: 5px solid;
            border-color: #2c5acc transparent transparent transparent;
          }
          &.right_::after {
            top: 5px;
            //   border-color: transparent #4d4d4d transparent transparent;
          }
        }
        // }
      }
      .add_ {
        margin-top: 20px;
        margin-bottom: 30px;
      }
      .foot_ {
        margin-top: 20px;
        padding-top: 17px;
        border-top: 1px #e7e7e7 solid;
        position: relative;
        &::after {
          content: "";
          display: block;
          height: 0;
          width: 0;
          position: absolute;
          top: 20px;
          left: 0;
          border: 5px solid;
          border-color: transparent transparent transparent #2c5acc;
        }
        &.right_::after {
          top: 5px;
          //   border-color: transparent #4d4d4d transparent transparent;
        }
      }
      .card_info {
        margin-right: 22px;
      }
      .card_1 {
        color: #2c5acc;
        margin-top: 20px;
        width: 144px;
        height: 30px;
        line-height: 30px;
        border-left: 3px #2c5acc solid;
        background: #fafafa;
        text-align: center;
        margin-bottom: 20px;
        font-weight: 500;
      }
      .modify_info {
        .mr_ {
          margin-right: 8px;
        }
      }
    }
    .tables_ {
      width: 100%;
      background-color: #fff;
      padding: 27px 29px 0 29px;
      border-radius: 10px;
      .tit_ {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 25px;
      }
      .img_ {
        width: 10px;
        height: 10px;
        margin-right: 5px;
      }
      .mt_20 {
        margin-top: 20px;
      }
      .mt_10 {
        margin-top: 10px;
      }
    }
  }
  .step_3 {
    color: #394155;
    padding-top: 27px;
    // padding: 27px 59px 0 61px;
    background-color: #fff;
    .cicle {
      width: 10px;
      height: 10px;
    }
    .tit {
      margin-right: 10px;
      font-weight: 500;
      &.tit1 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &.tit2 {
        height: 40px;
        overflow: hidden;
        display: block;
        width: 100%;
        max-width: 100%;
        margin-right: 0;
      }
    }
    .dec {
      margin-left: 10px;
      color: #999999;
    }
    .exp {
      margin-left: 10px;
    }
    .mt_ {
      margin-top: 10px;
      a {
        position: relative;
      }
      input {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .addlist {
      width: 100%;
      height: 150px;
      overflow-y: auto;
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-top: 16px;
      input {
        outline: none;
        border: none;
        margin: 20px;
        width: 90%;
      }
      .list-item {
        .remove {
          margin-left: 10px;
          color: #e5002d;
          font-size: 18px;
        }
        .blue {
          margin-right: 5px;
        }
        display: flex;
        align-items: center;
        padding: 0 5px;
        // margin: 10px;
      }
    }
  }
  .bottom_ {
    height: 177px;
    width: 100%;
    border-radius: 10px;
    background-color: #fff;
    margin-top: 20px;
    padding: 20px 29px 35px 29px;
    .remark_ {
      font-weight: 500;
      font-size: 16px;
    }
  }
}
.fixbg1 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  .ant-spin-spinning {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    left: 0;
    margin: auto;
  }
}
.hover_bold {
  cursor: pointer;
}
.hover_bold:hover {
  font-weight: bold;
}
</style>

<script>
import api from "@/utils/api";
export default {
  data() {
    return {
      columns: [
        {
          title: this.$t("bankInfo[0]"),
          dataIndex: "name"
        },
        {
          title: this.$t("bankInfo[1]"),
          dataIndex: "age"
        },
        {
          title: this.$t("bankInfo[2]"),
          dataIndex: "address"
        },
        {
          title: this.$t("bankInfo[3]"),
          scopedSlots: { customRender: "do" }
        }
      ],
      value: "",
      claimsItem: {},
      fileList: [],
      uploadFileList: [],
      imgVisible: false,
      showImgList: [],
      statusOptionsclaim: [
        {
          value: "39",
          text: "Cancelled "
        },
        {
          value: "10",
          text: "Image upload failed"
        },
        {
          value: "20",
          text: "Image upload failed"
        },
        {
          value: "30",
          text: "Claims materials to be reviewed"
        },
        {
          value: "40",
          text: "Material review,file case"
        },
        {
          value: "50",
          text: "Claim materials failed to pass the review"
        },
        {
          value: "05",
          text: "Under Reviewing "
        },
        {
          value: "07",
          text: "Additional Information Requested"
        },
        {
          value: "06",
          text: "Apply Approval by Fronting Comp"
        },
        {
          value: "08",
          text: "Adjudication Completed"
        },
        {
          value: "09",
          text: "Finalized"
        },
        {
          value: "10",
          text: "Payment Processing"
        },
        {
          value: "11",
          text: "Paid"
        },
        {
          value: "12",
          text: "Pending"
        },
        {
          value: "13",
          text: "Canceled"
        }
      ],
      isLoading: false,
      language: ""
    };
  },
  filters: {
    filterStatusClaim: (val, statusOptionsclaim) => {
      console.log(val, "val");
      if (val === "" || val === null || val === undefined) {
        return "--";
      } else {
        let textCon = "";
        statusOptionsclaim.map(item => {
          if (item.value == val) {
            textCon = item.text;
          }
        });
        return textCon;
      }
    }
  },
  mounted() {
    this.claimsItem = JSON.parse(localStorage.getItem("supplementDetail"));
    console.log(this.claimsItem);
    this.uploadFileList = [];
    let lang = localStorage.getItem("lang");
    this.language = lang == "en-us" ? "ENGLISH" : "CHINAESE";
    this.getPreAppbjFileList();
  },
  methods: {
    goDetail() {
      this.$router.push({
        name: "ClaimDetail",
        query: {
          iclaimsId: this.claimsItem.claimsId
        }
      });
    },
    changeAccount() {
      this.$router.push({ name: "Info" });
    },
    submit() {
      if (
        this.claimsItem.claimsType != "1" &&
        this.claimsItem.claimsType != "2"
      ) {
        let list = this.fileList.filter(item => item.isFill == 1);
        for (var i = 0; i < list.length; i++) {
          if (
            !this.uploadFileList.filter(item => item.imageType == list[i].type)
              .length > 0
          ) {
            list[i].ifUp = false;
            if (this.$i18n.locale == "zh-cn") {
              this.$message.error("请上传" + list[i].cName);
            } else {
              this.$message.error("Please upload " + list[i].eName);
            }
          } else {
            list[i].ifUp = true;
          }
        }
        if (list.filter(item => item.ifUp == false).length == 0) {
          this.uploadFile();
        }
      } else {
        this.uploadFile();
      }
    },
    uploadFile() {
      let uploadType = "patch";
      if (this.claimsItem.claimsProgressCode == "07") {
        uploadType = "claimsPatch";
      }
      let param = {
        claimsId: this.claimsItem.cliamsId,
        iclaimsId: this.claimsItem.iclaimsId,
        uploadType: uploadType,
        list: this.uploadFileList,
        remark: this.value
      };
      this.isLoading = true;
      api
        .patch(param)
        .then(res => res.data)
        .then(data => {
          this.isLoading = false;
          console.log(data, "dataeeee");
          if (data.code == "200") {
            this.$router.push({
              name: "ClaimSupplement"
            });
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    removeFile(index) {
      this.uploadFileList.splice(index, 1);
      console.log(this.uploadFileList, "删除的剩下的");
    },
    uploadPhoto(e, type) {
      // 利用fileReader对象获取file
      var file = e.target.files[0];
      var filesize = file.size / 1024;
      var filename = file.name;
      if (filesize > 20000) {
        if (this.language == "CHINAESE") {
          this.$message.error("上传文件大小超过20MB,请压缩后再试");
        } else {
          this.$message.error(
            "File size exceeds 20MB, please compress and try again"
          );
        }
      } else {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        var this_ = this;
        reader.onload = function(e) {
          // 读取到的图片base64 数据编码 将此编码字符串传给后台即可
          var imgcode = e.target.result;
          this.uploadFileList.push({
            imagStr: imgcode,
            imageName: filename,
            imageType: type
          });
        };
      }
    },
    getPreAppbjFileList() {
      let param = {
        iclaimsId: this.claimsItem.cliamsId,
        applyType: "LPSQ"
      };
      if (
        this.claimsItem.claimsType == "1" ||
        this.claimsItem.claimsType == "2"
      ) {
        param = {
          claimsId: this.claimsItem.cliamsId
        };
        api
          .getPrePatchFileType(param)
          .then(res => res.data)
          .then(data => {
            this.fileList = data.data.list;
          });
      } else {
        api
          .getPreAppbjFileList(param)
          .then(res => res.data)
          .then(data => {
            this.fileList = data.data;
          });
      }
    },
    back() {
      this.$router.push({
        name: "ClaimSupplement"
      });
    },
    exam(index) {
      this.imgVisible = true;
      this.showImgList = this.fileList[index].templateList;
    }
  }
};
</script>
